import { RadioPointInterface } from '../interfaces/radio-point.interface';
import { FormConfigBase } from './abstract/form-config-base.class';

export class RadioPointModel extends FormConfigBase {
  description: string;
  optionTwoSelectedSubText?: string;
  optionOneText: string;
  optiontwoText: string;
  checked?: boolean;
  id?: string;

  constructor(obj: RadioPointInterface) {
    super(obj);

    this.description = obj.description ? obj.description : '';
    this.optionTwoSelectedSubText = obj.optionTwoSelectedSubText ? obj.optionTwoSelectedSubText : '';
    this.optionOneText = obj.optionOneText ? obj.optionOneText : '';
    this.optiontwoText = obj.optiontwoText ? obj.optiontwoText : '';
    this.checked = !!obj.checked;
    this.id = obj.id;
  }

}
